<template>
  <div class="pd-y-3 pd-x-2 custom-template">
    <el-row
      type="flex"
      class="height-100 custom-flex"
      :class="
        positionNavNextTo == 'left' ? 'chang-to-bottom' : 'nochang-to-bottom'
      "
    >
      <el-col v-if="positionNavNextTo == 'left'" :span="24" :lg="8">
        <NavNextTo :type="type" :positionNavNextTo="positionNavNextTo"/>
      </el-col>
      <el-col :span="24" :lg="16">
        <div class="box-tat-action">
          <slot></slot>
        </div>
      </el-col>
      <el-col v-if="positionNavNextTo == 'right'" :span="24" :lg="8">
        <NavNextTo :type="type" :positionNavNextTo="positionNavNextTo"/>
      </el-col>
    </el-row>
    <div id="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/template/Footer";
import NavNextTo from "@/components/template/NavNextTo";

export default {
  props: {
    positionNavNextTo: {
      type: String,
      default() {
        return "left";
      },
    },
    type: {
      type: String,
      default() {
        return "signin";
      },
    },
  },
  components: {
    Footer,
    NavNextTo,
  },
};
</script>

<style scoped>
.box-tat {
  background-image: url("../assets/bg-tat.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;

  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

}
.box-tat.left {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.box-tat.right {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
